import { Dispatch, SetStateAction, useState } from 'react';

interface UseDataStateResult<T> {
  data: T[];
  setData: Dispatch<SetStateAction<T[]>>;
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

function useDataState<T>(loading = false, defaultValue: T[] = []): UseDataStateResult<T> {
  const [isLoading, setIsLoading] = useState<boolean>(loading);
  const [data, setData] = useState<T[]>(defaultValue);

  return {
    data,
    setData,
    isLoading,
    setIsLoading,
  };
}

export default useDataState;
